import { createLucideIcon } from 'lucide-react';
export const SingleUserCog = createLucideIcon('single-user-cog', [
  [
    'path',
    {
      d: 'M11 13C6 13.2157 6 19 6 19',
      key: '63gsod',
    },
  ],
  [
    'path',
    {
      d: 'M13.4999 17L12.274 16.2',
      key: '1shfoe',
    },
  ],
  [
    'path',
    {
      d: 'M13.4999 19.2L12.274 19.8',
      key: '1yyiz7',
    },
  ],
  [
    'path',
    {
      d: 'M15.0998 15V16.2',
      key: 'fwy5mk',
    },
  ],
  [
    'path',
    {
      d: 'M15.0998 19.8V21',
      key: 'creyse',
    },
  ],
  [
    'path',
    {
      d: 'M15.1 19.8C16.0941 19.8 16.9 18.9941 16.9 18C16.9 17.0059 16.0941 16.2 15.1 16.2C14.1059 16.2 13.3 17.0059 13.3 18C13.3 18.9941 14.1059 19.8 15.1 19.8Z',
      key: '1d2dpm',
    },
  ],
  [
    'path',
    {
      d: 'M16.6289 17L17.9078 16.2',
      key: 'hrlyro',
    },
  ],
  [
    'path',
    {
      d: 'M16.6289 19.2L17.9078 19.9258',
      key: '1dm7qn',
    },
  ],
  [
    'path',
    {
      d: 'M7 9C7 6.78906 8.78906 5 11 5C13.2109 5 15 6.78906 15 9C15 11.2109 13.2109 13 11 13C8.78906 13 7 11.2109 7 9Z',
      key: '1fa48h',
    },
  ],
]);
